var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import dayTwo from "./dayTwo";
import { getColumn } from "./util";
var getRow = getColumn(72.2, 22).getRow;
export var image = "https://assets.swoogo.com/uploads/full/2188232-636d288e5ff94.jpg";
export default __spreadArray(__spreadArray([], dayTwo, true), [
    getRow({ label: "B11.1 Security Monitoring Across Multiple Clouds: A hybrid cloud approach based on experience", height: 5.8, modal: "https://player.vimeo.com/video/766842671?h=8f09331200" }),
    getRow({ label: "B11.2 Which Security Controls are Most Effective? Using quantitative cyber risk management", height: 5, modal: "https://player.vimeo.com/video/766842085?h=a128c2f280" }),
    getRow({ label: "B11.3 Challenging Your Leadership in Cyber", height: 3.5, modal: "https://player.vimeo.com/video/766841274?h=302eb92a11" }),
    getRow({ label: "B11.4 Use of SABSA in AXA Group", height: 3.3, modal: "https://player.vimeo.com/video/766840602?h=787922d0bf" }),
    getRow({ label: "B12.2 Bridging the Gap Between Cyber, Risk and IT", height: 3.3, modal: "https://player.vimeo.com/video/766839210?h=ae8a98492a" }),
    getRow({ label: "B12.3 Building an effective Insider Threat Program", height: 3.3, modal: "https://player.vimeo.com/video/766839005?h=fcb9a59281" })
], false);
